import * as React from "react";
import {cx} from "emotion";

import "./share-target-box.scss";

import {cs}         from "@Common/react/chain-services";
import {upperCase1} from "@Common/utils/strings";

import {AccountLine} from "../common/account-line";
import {Header}      from "../common/header";

export const ShareTargetBox = (
    {
        loggedIn, account, unselected, onRemoveAccount, type, typeName,
        isShared, message=undefined,
    }
) => cs(
    ({}) => (
        <div
            className="share-target-box-4hd"
            xd-qa-type="card" xd-qa-name={upperCase1(type)}
        >

            <div className={cx("box", {"has-content": !unselected.value})}>

                {Header({
                    type,
                    typeName,
                    login_url: account?.login_url,
                    unselected: loggedIn && unselected,
                })}

                {!unselected.value && (
                    <div className="content">
                        { !loggedIn ? (
                            <div className="action">
                                <a
                                    className={cx("link-btn", { "disabled": !account?.login_url })}
                                    href={account?.login_url}
                                    xd-qa-type="link"
                                    xd-qa-name={"Add Account " + upperCase1(type)}
                                >
                                    {account?.login_url ? "Add Account" : "Unavailable"}
                                </a>
                            </div>
                        ) : (
                            AccountLine({
                                onRemoveAccount,
                                account,
                                type,
                            })
                        )}

                        {message && loggedIn && (
                            <div className="message">
                                {message}
                            </div>
                        )}

                        {isShared?.(type) && (
                            <div className="warning">
                                This event has been shared on {upperCase1(type)} before
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    ),
);



